export default {
  initializing: "initializing",
  loading: "loading",
  authenticated: "authenticated",
  unauthenticated: "unauthenticated",
  refresh: "refreshing-token"
}

export const ACCESS_TOKEN_KEY = "xopri-jwt-actoken"
export const REFRESH_TOKEN_KEY = "xopri-jwt-retoken"